
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.8333 15.8333C19.8333 16.2935 19.4602 16.6666 18.9999 16.6666C18.5397 16.6666 18.1666 16.2935 18.1666 15.8333L18.1666 4.16658C18.1666 3.70635 18.5397 3.33325 18.9999 3.33325C19.4602 3.33325 19.8333 3.70635 19.8333 4.16658L19.8333 15.8333ZM10.4225 3.57733C10.0971 3.25189 9.56943 3.25189 9.244 3.57733C8.91856 3.90277 8.91856 4.4304 9.244 4.75584L13.6547 9.16659L2.33325 9.16659C1.87301 9.16659 1.49992 9.53968 1.49992 9.99992C1.49992 10.4602 1.87301 10.8333 2.33325 10.8333L13.6547 10.8333L9.244 15.244C8.91856 15.5694 8.91856 16.0971 9.244 16.4225C9.56943 16.7479 10.0971 16.7479 10.4225 16.4225L16.2558 10.5892C16.5813 10.2637 16.5813 9.7361 16.2558 9.41066L10.4225 3.57733Z","fill":"#16171F"}})])
          )
        }
      }
    